import  React, {useState, useEffect} from "react";

import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { searchUnits } from "utils";
import { api } from "services";

import FlowableFinder from "../Common/FlowableFinder";
import styles from "./styles.css";

const FlowableUnitSearch = (props) => {

	const [ preselectedOptions, setPreselectedOptions ] = useState();

	useEffect(()=> {
		if(props.config.value) {
			const promises = [];

			if(isNonEmptyArray(props.config.value)) {
				props.config.value.forEach(val => {
					if(isNonEmptyString(val)) {
						promises.push(api.unit.get({ id: val }));	
					}
				});
			} else if(isNonEmptyString(props.config.value)) {
				promises.push(api.unit.get({ id: props.config.value }));	
			}

			Promise.all(promises).then((results) => {
				const unit = []
				results.forEach(data => {
					unit.push({
						key: data.id,
						value: data.id,
						text: data.name,
						unit: {
							...data
						},
						content: (
							<div className="optionContent">
								<span>{data.name}</span>
							</div>
						),
					})
				});
	
				setPreselectedOptions(unit);
			});
		}
	}, [props.config.value]);
	
	const searchChange = (selectedOptions) => {
		setPreselectedOptions(selectedOptions);
		const values = isNonEmptyArray(selectedOptions) ? selectedOptions.map(option => option.unit.id) : null;
		props.onChange(values);
	};

	return (
		<div className={styles.flowableUnitSearch}>
			<FlowableFinder
				search={searchUnits}
				searchChange={searchChange}
				preselectedOptions={preselectedOptions}
				key={props.config.id}
				{...props}
			/>
		</div>
	)
}

export default FlowableUnitSearch;
